import React, { FC } from "react";
import cls from "./customFooter.module.scss"
import {IFooter} from "../MainLayout"
import CustomToTop from "./CustomToTop";
import Link from "next/link";
import {domainUrl} from "../../../../helper";
import BuilderSection from "../../../builder/BuilderDataRender";
import CustomSubscriptionForm from "./CustomSubscriptionForm";

const CustomFooter: FC<IFooter> = (
    {
        logoPath,
        footerCopyRightValue,
        footerPoweredValue,
        showSubscriptionStyle,
        arrFooterTrack,
        footerMenus,
        showFooterEmailStyle,
        showFooterPhoneStyle,
        footerEmailValue,
        telephone,
        showFooterAddressStyle,
        footerAddressValue,
        dbName,
        socialsFooter,
        translationsData,
        cacheControlVersion,
        showFooterMenuCls,
        setPadding,
        showFooterContactCls,
        isMobile,
        themeOptions,
        selectedLocale,
        domain,
        getBuilderData,
        currencies,
        backOrderValue,
        recaptchaActive
    }
) => {
    const footerStylesCorrectionToggle = () => {
        const classnames = {
            footer_padding_off: "",
            body_none: {},
            copyright_border_none: "",
            empty_footer: ""
        };
        if (isMobile && showSubscriptionStyle === "none") {
            classnames.footer_padding_off = cls.footer_padding_off;
            classnames.body_none = { display: "none" }
            classnames.copyright_border_none = cls.copyright_border_none
            if (!footerPoweredValue && !footerCopyRightValue) {
                classnames.footer_padding_off = cls.empty__footer;
            }
        }
        return classnames
    }

    const showFooterText = {
        "true": (
            <div className={`${cls.copyright} ${footerStylesCorrectionToggle().copyright_border_none}`}>
                <div>{footerCopyRightValue}</div>
                <div dangerouslySetInnerHTML={{__html: footerPoweredValue}}/>
            </div>
        ),
        "false": null
    }
    const FooterContentHandle = () => {
        //show footer from static store
        if (typeof themeOptions?.show_footer !== "boolean" || themeOptions?.show_footer || isMobile) {
            return (
                <div className={`${cls["footer-container"]} container`}>
                    <div className={cls["footer-body"]} style={footerStylesCorrectionToggle().body_none}>
                        <div className={cls['footer-main-info']}>
                            <div className={cls.footer_logo_block}>
                                <div className={cls.logo_div}>
                                    <Link href="/" prefetch={false}>
                                        <a>
                                            <img
                                                src={domainUrl(`${dbName}/${logoPath}?v=${cacheControlVersion}`)}
                                                alt="Logo"
                                                // loading="eager"
                                                loading="lazy"
                                                width="200"
                                                height="40"
                                            />
                                        </a>
                                    </Link>
                                </div>

                                {translationsData.FooterText !== "empty" ?
                                    <div className={cls['footer_text']}>
                                        <p dangerouslySetInnerHTML={{__html: translationsData.FooterText}}/>
                                    </div>
                                    : null
                                }
                                <div
                                    className={`${cls["footer-newsletter__social-links"]} ${cls["social-links"]} ${cls["social-links--shape--circle"]}`}>
                                    <ul className={cls["social-links__list"]}>
                                        {socialsFooter?.map(({
                                                                 name: socialName,
                                                                 icon: socialIcon,
                                                                 link: socialLink
                                                             }, index) => (
                                            <li className={cls["social-links__item"]} key={index}>
                                                <Link
                                                    className={`${cls["social-links__link"]} ${cls["social-link-color"]}`}
                                                    href={socialLink}
                                                    prefetch={false}
                                                    style={{
                                                        position: "relative",
                                                        width: "100%",
                                                        height: "100%"
                                                    }}
                                                >
                                                    <a target="_blank">
                                                        <img
                                                            src={domainUrl(`${dbName}/storage/${socialIcon}`)}
                                                            alt={socialName}
                                                            loading="lazy"
                                                            width="30"
                                                            height="30"
                                                        />
                                                    </a>
                                                </Link>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                            <div className={cls["footer_menus_list"]}>
                                {arrFooterTrack?.map(({href, id}: { href: string, id: string }, index: number) => (
                                    <div key={index} className={cls["trackingNumber-fms"]}>
                                        <Link href={href} prefetch={false}><a>{id}</a></Link>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className={`${cls["footer-first-column"]} ${cls[showFooterMenuCls]}`}>
                            <h3 className={cls["footer-newsletter__title"]}>
                                {translationsData?.FooterMenu}
                            </h3>
                            <div className={cls["footer_menus_list"]}>
                                {footerMenus?.map(({
                                                       url_key = "",
                                                       name: menuName,
                                                       target,
                                                   }, index: number) => {
                                    return (
                                        <div key={index} className={cls["footerLinks-fms"]}>
                                            <Link href={url_key}
                                                  prefetch={false}>
                                                <a {...target}>{menuName}</a>
                                            </Link>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                        <div className={`${cls["footer-newsletter-hide"]} ${cls[showFooterContactCls]}`}>
                            <h3 className={cls["footer-newsletter__title"]}>
                                {translationsData?.FooterContacts}
                            </h3>
                            <div className={`${cls["footer-newsletter__social-links"]} ${cls["footer-contacts"]}`}>
                                <ul className={cls["footer-contacts__contacts"]}>
                                    <li className={cls.contactsAddress_list}>
                                        <div className={cls.contactsAddress} style={{display: showFooterEmailStyle}}>
                                            <Link href={`mailto:${footerEmailValue}`} prefetch={false}><a>{footerEmailValue}</a></Link>
                                        </div>
                                        <div className={cls.contactsAddress} style={{display: showFooterPhoneStyle}}>
                                            <Link href={`tel:${telephone}`} prefetch={false}><a>{telephone}</a></Link>
                                        </div>
                                        <div className={cls.contactsAddress}>
                                            <div style={{display: showFooterAddressStyle}}>{footerAddressValue}</div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <CustomSubscriptionForm
                            translationsData={translationsData}
                            showSubscriptionStyle={showSubscriptionStyle}
                        />
                    </div>
                    {showFooterText[`${!!footerCopyRightValue || !!footerPoweredValue}`]}
                </div>
            )
        } else {
            const [{
                code: selectedCurrCode = "",
                symbol: selectedCurrSymbol = "",
                exchange_rate: {rate: selectedCurrRate = "1"} = {},
            } = {}] = currencies
            const builderProps = {
                getBuilderData,
                domain,
                dbName,
                translationsData,
                selectedLocale,
                currencies,
                backOrderValue,
                selectedCurrItems: {selectedCurrCode, selectedCurrRate, selectedCurrSymbol},
                isMobile,
                recaptchaActive
            }
            return <BuilderSection tab={5}  {...builderProps} />
        }
    }
    return (
        <div className={`
            ${cls["site-footer"]}
            ${footerStylesCorrectionToggle().footer_padding_off}
        `} style={themeOptions?.show_footer === false && !isMobile ? {padding: "unset"} : setPadding ? {} : {padding: "56px 0 32px 0"}}>
            <FooterContentHandle />
            <CustomToTop/>
        </div>
    );
};

export default CustomFooter;
